import React from 'react';
import { Sparkles } from 'lucide-react';

interface LaikaAvatarProps {
  size?: number;
  showStatus?: boolean;
  className?: string;
}

const LaikaAvatar: React.FC<LaikaAvatarProps> = ({
  size = 40,
  showStatus = false,
  className = '',
}) => {
  const iconSize = Math.max(14, Math.round(size * 0.46));

  return (
    <div
      className={`laika-avatar ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <Sparkles size={iconSize} className="laika-avatar-icon" strokeWidth={2.25} />
      {showStatus && <span className="laika-avatar-status" />}
    </div>
  );
};

export default LaikaAvatar;
